import React, { useCallback, useEffect, useState } from 'react'
import configuredAxios from '../../configured-axios'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { CONTAINERS_URL } from '../api_urls'
import { PencilSquare } from 'react-bootstrap-icons'
import { Container, Button, Col, Row } from 'react-bootstrap'

import ContainerEditModal from './ContainerEditModal'
import RepairList from '../repairs/RepairsList'
import ContainerRunList from './ContainerRunList'

function ContainerBox(props) {
  const [containerBox, setContainerBox] = useState()
  const [showModal, setShowModal] = useState(false)

  const { id } = useParams()

  const handleModalClose = () => setShowModal(false)
  const handleModalShow = () => setShowModal(true)

  const loadContainerData = useCallback(() => {
    configuredAxios.get(CONTAINERS_URL + '/' + id).then((res) => {
      setContainerBox(res.data)
    }).catch(() => {
      toast.error('Could not retrieve Container')
    })
  }, [id])

  useEffect(() => {
    loadContainerData()
  }, [loadContainerData])

  if (containerBox) {
    return (
      <Container>
        <h2>Container Detail</h2>
        {containerBox && (
          <Container>
            <Container>
              <Row className='mb-4'>
                <Col>
                  {props.authenticated && (
                    <>
                      <Button variant='outline-dark' onClick={handleModalShow}>
                        <PencilSquare className='edit-icon' /> Edit
                        Container
                      </Button>
                      <ContainerEditModal
                        show={showModal}
                        handleClose={handleModalClose}
                        onEditContainer={() => {
                          loadContainerData()
                        }}
                        containerBox={containerBox}
                        containerId={containerBox.id}
                      />
                    </>
                  )}
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col xs={4}>Number:</Col>
                <Col>{containerBox.number}</Col>
              </Row>
              <Row className='mb-2'>
                <Col xs={4}>Size:</Col>
                <Col>{containerBox.size}</Col>
              </Row>
              <Row className='mb-2'>
                <Col xs={4}>Description:</Col>
                <Col>{containerBox.description}</Col>
              </Row>
              <Row className='mb-2'>
                <Col xs={4}>Current Location:</Col>
                <Col><b>{containerBox.currentLocation}</b></Col>
              </Row>
            </Container>
            <ContainerRunList
              containerId={id}
              containerRunsChanged={() => {
                loadContainerData()
              }}
            />
            <RepairList
              repairs={containerBox.repairs}
              containerBoxId={containerBox.id}
              onRepairFormSubmit={() => {
                loadContainerData()
              }}
            />
          </Container>
        )}
      </Container>
    )
  } else {
    return <div />
  }
}

export default ContainerBox
